















import { Component, Prop, Vue } from "vue-property-decorator";
import Paginates from "vuejs-paginate";

@Component({
  name: "Paginate",
  components: {
    Paginates,
  },
})
export default class Paginate extends Vue {
  @Prop({ default: 1 })
  public page: number;
  @Prop({ default: 1 })
  public pageCount: number;

  public changePage(page) {
    this.$emit("page-change", page);
  }
}
